<template>
  <v-dialog v-model="doc_modal" max-width="500" persistent>
    <v-card :loading="loading">
      <v-card-title></v-card-title>
      <v-card-text>
        <v-row >
          <v-col cols="6">
            <v-select outlined="" label="Doc Type" dense
            :hide-details="!form_errors.doc_type"
            :items="doc_types"
            v-model="form_data.doc_type"
            :error-messages="form_errors.doc_type"
            @change="setDocTitle()"
            ></v-select>
          </v-col>
          <v-col cols="6">
            <v-text-field
            outlined=""
            label="Doc. Name"
            v-model="form_data.doc_title"
            dense=""
            :disabled="form_data.doc_type != 27"
            :error-messages="form_errors.doc_title"
            :hide-details="!form_errors.doc_title"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-file-input
              v-model="form_data.file"
              color="primary"
              label="Upload Document"
              placeholder="Select your file"
              append-icon="mdi-paperclip"
              prepend-icon=""
              outlined
              :show-size="1000"
              dense=""
              :error-messages="form_errors.file"
              :hide-details="!form_errors.file"
              v-if="!form_data.is_dropbox"
            >
            </v-file-input>
            <VueDropboxPicker
            :api-key="dropboxApiKey"
            link-type="direct"
            :multiselect="false"
            :folderselect="false"
            @cancel="onCancel"
            @picked="onPicked"
            v-show="form_data.is_dropbox">
              <v-text-field
                v-model="form_data.dropbox_file.name"
                color="primary"
                label="Select Document"
                placeholder="Click to select"
                append-icon="mdi-dropbox"
                prepend-icon=""
                outlined
                dense=""
                readonly=""
                :error-messages="form_errors.link"
                :hide-details="!form_errors.link"
              >
              </v-text-field>
            </VueDropboxPicker>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="py-0">
            <v-spacer></v-spacer>
            <v-switch label="Dropbox" v-model="form_data.is_dropbox" class="my-0"></v-switch>
         </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn color="error" @click="setModal(false)" :disabled="loading">Cancel</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" :loading="loading" @click="uploadFiles(form_data)">
          Upload
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState,mapMutations,mapActions } from "vuex";
import VueDropboxPicker from 'vue-dropbox-picker';
export default {
  name: "UploadDocument",
  components : {
    VueDropboxPicker
  },
  data: () => ({
    dropboxApiKey : process.env.VUE_APP_DROPBOX_KEY,
    form_data : {
      file : null,
      doc_type : '',
      doc_title : '',
      is_dropbox : false,
      dropbox_file : {}
    }
  }),
  watch : {
    'doc_modal' : {
      handler(val){
        if(!val){
          this.form_data = {
            file : null,
            doc_type : '',
            doc_title : '',
            is_dropbox : false,
            dropbox_file : {}
          }
          this.setDocumentData({key : 'form_errors',value : []})
        } else {
          this.getDocTypes()
        }
      }
    }
  },
  computed: {
    ...mapState("document", ["doc_modal", "type","loading","form_errors","doc_types"])
  },
  methods : {
    ...mapActions("document",["uploadFiles","getDocTypes"]),
    ...mapMutations("document",['setModal','setDocumentData']),
    setDocTitle(){
      let _self = this
      let type =  this.doc_types.filter((type) => {
        return type.value == _self.form_data.doc_type
      })
      this.form_data.doc_title = type[0].text
    },
    onCancel() {
      console.log('onCancel')
      this.form_data.dropbox_file = {}
    },
    onPicked(files){
      this.form_data.dropbox_file = files[0]
    }
  }
};
</script>

<style>
</style>